import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../../core/services/auth.service';
import { DataStoreService } from '../../core/services/data-store.service';

@Component({
  selector: 'app-login-page',
  imports: [CommonModule, FormsModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css'
})
export class LoginPageComponent {
  email = '';
  password = '';
  errorMessage = '';
  protected readonly credentials: { email: string; password: string };

  constructor(
    private readonly authService: AuthService,
    private readonly dataStoreService: DataStoreService,
    private readonly router: Router
  ) {
    this.credentials = this.authService.getDemoCredentials();
    this.dataStoreService.getCollectionCount('customers');
  }

  login(): void {
    this.errorMessage = '';

    if (this.authService.login(this.email.trim(), this.password.trim())) {
      void this.router.navigate(['/dashboard']);
      return;
    }

    this.errorMessage = 'Use the demo email and password shown below the form.';
  }
}